import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const ReviewsCarousel = dynamic(() => import('./ReviewsCarousel').then((m) => ({ default: m.ReviewsCarousel })));

const ReviewsCarouselConfig = {
  name: 'ReviewsCarousel',
  inputs: [
    {
      name: '_reviews',
      type: 'list',
      subFields: [
        {
          name: 'review',
          type: 'reference',
          model: 'review',
        },
      ],
    },
  ],
};

Builder.registerComponent(ReviewsCarousel, ReviewsCarouselConfig);
